import Vue from 'vue';
import SearchConfig from '@sun-chemical/system-config/search-config';
import axios from 'axios';
import { cloneObject } from 'utils';
import base from 'stores/search-base/getters';

export default {
  ...base,
  documentServiceClient(state, getters, rootState) {
    if (!state.documentServiceClient) {
      state.documentServiceClient = axios.create({
        baseURL: `${payload.services.documentservice.url}/api/v2/document`
      });

      if (rootState.user.activeUser) {
        state.documentServiceClient.defaults.headers.common.Authorization = `Bearer ${rootState.user.activeUser.token}`;
      }
    }

    return state.documentServiceClient;
  },
  filters(state, getters, rootState, rootGetters) {
    const filters = cloneObject(state.filterConfig);
    const { urlFilters } = getters;

    Object.keys(filters).forEach((filterCode) => {
      const aggs = getters.aggregations && Array.isArray(getters.aggregations[filterCode]) ? getters.aggregations[filterCode] : null;
      const config = cloneObject(filters[filterCode]);

      if (!config.accessLevel || rootGetters['user/permissions'][config.accessLevel]) {
        const filterParam = SearchConfig.getMap()[filterCode].param;

        Vue.set(filters[filterCode], 'param', filterParam);

        if (config.type === 'multi') {
          filters[filterCode].options = [];
          config.options.forEach((option) => {
            const filterObject = {
              ...option,
              selected: null,
              disabled: !(aggs && aggs.indexOf(option.code) !== -1)
            };

            if (urlFilters.hasOwnProperty(filterParam)) {
              let activeFilters = urlFilters[filterParam];
              if (typeof activeFilters === 'string') {
                activeFilters = [activeFilters];
              }
              filterObject.selected = activeFilters.indexOf(option.code) > -1;
            }

            // Prevent disabling currently active filters
            if (filterObject.selected && filterObject.disabled) {
              filterObject.disabled = false;
            }

            filters[filterCode].options.push(filterObject);
          });
        }
      } else {
        delete filters[filterCode];
      }
    });

    const minDocDateConfig = SearchConfig.getMap().min_document_created_date;
    filters.min_document_created_date = {
      param: minDocDateConfig.param,
      type: 'onlyChangedDocs',
      selected: urlFilters.hasOwnProperty(minDocDateConfig.param) ? !!urlFilters[minDocDateConfig.param] : false
    };

    return {
      generic: filters
    };
  },
  activeIndustries() {
    return null;
  },
  activeTab(state, getters) {
    return getters.urlFilters.hasOwnProperty('tab')
    && state.availableTabs.indexOf(getters.urlFilters.tab) > -1
      ? getters.urlFilters.tab
      : 'search';
  },
  isMySheets(state, getters) {
    return getters.activeTab === 'mysheets';
  },
  hasActiveFilters(state, getters) {
    if (getters.urlFilters && typeof getters.urlFilters === 'object') {
      const filterKeys = Object.keys(getters.urlFilters).filter((key) => key !== 'tab');

      return filterKeys.length > 0;
    }

    return false;
  },
  isMobile(state) {
    return state.documentWidth <= 960;
  },
  basketIds(state) {
    return new Set(state.basket.map((asset) => asset.id));
  },
  basketContainsMsdsDocuments(state) {
    return state.basket
      .filter((doc) => doc.isVirtual && doc.type === 'virtual_msds')
      .length > 0;
  },
  selectAllProductsLimit(state, getters) {
    if (getters['user/isDocumentManager']) {
      return 500;
    }

    return 150;
  },
  selectAllProductsDocumentLimit(state, getters) {
    if (getters['user/isDocumentManager']) {
      return 0;
    }

    return 150;
  },
  isSelectAllDisabled(state, getters) {
    return getters.resultsTotal > getters.selectAllProductsLimit;
  },
  loadedAssets(state) {
    if (state.results && state.results.hits) {
      return state.results.hits.reduce((curr, hit) => [...curr, ...hit.assets], []);
    }

    return [];
  },
  loadedUniqueAssets(state, getters) {
    return [...new Map(getters.loadedAssets.map((asset) => [asset.id, asset])).values()];
  },
  uniqueLoadedAssetsCount(state, getters) {
    return getters.loadedUniqueAssets.length;
  },
  basketSize(state, getters) {
    return getters.basketIds.size;
  }
};
